import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from '../../../services/main/api.service';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { Router, ActivatedRoute } from '@angular/router';
import { Global } from '../../../services/global';
import { BaseCrudComponent } from '../../base-crud/base-crud.component';
import { TranslateService } from '@ngx-translate/core';

import { Observable, from, of, concat } from 'rxjs';
import { mergeMap, catchError, timeout, retry, debounceTime, distinctUntilChanged, map, last, concatMap } from 'rxjs/operators';

@Component({
    selector: 'app-users',
    templateUrl: './users.component.html',
    styleUrls: ['./users.component.css']
})
export class UsersComponent extends BaseCrudComponent {

    translations: any;
    listUsers: any;
    listDocs: any;
    listPerms: any;
    loadingRequired: any;
    branches: any;

    listZones: any;
    listChiefs: any;
    listSupervisor: any;
    listAgents: any;

    //counter
    listSpecialAgents:any;
    listCities:any;
    listSalesOffices:any;
    listOrderTypes:any;

    //payments
    listCenters:any = [];

    constructor(
        srv: ApiService,
        modalService: NgbModal,
        storage: Storage,
        router: Router,
        private route: ActivatedRoute,
        public translate: TranslateService
    ) {
        super(srv, modalService, storage, router);

        this.read_url = 'users';
        this.create_url = 'user';
        this.update_url = 'user/update';
        this.delete_url = 'user/delete';
        this.search_fields = ['ext_id', 'name', 'role_name', 'email', 'supervisor_name'];
        this.listUsers = [];
        this.listDocs = [];
        this.listPerms = [];
        this.branches = [];

        this.listChiefs = [];
        this.listSupervisor = [];
        this.listZones = [];
        this.listAgents = [];

        //counter
        this.listSpecialAgents = [];
        this.listCities = [];
        this.listSalesOffices = [];
        this.listOrderTypes = [];

        this.loadingRequired = false;

        this.reload.subscribe(val => {
            if (val) {
                super.clearData();
                this.getList();
            }
        });
    }

    ngOnInit() {
        this.translate.getTranslation(this.translate.currentLang)
            .subscribe((translations) => {
                this.translations = translations;
                super.ngOnInit();
                this.getList();
            });
    }

    public getRoles() {
        var par_url = 'roles';

        return this.srv.getCall(par_url).pipe(
            mergeMap(x => {
                //console.log(x);
                let mydata: any = { status: false, message: '', data: [] };
                mydata = x;

                if (mydata.status == true) {
                    return of(mydata.data);
                }
                else {
                    return of(false);
                }
            }),
            //timeout(MAX_TIME),
            catchError(data => of(false))
        );
    }

    openCreateModal(content: any) {
        this.c_obj = {};
        this.c_obj.permList = [];
        super.openCreateModal(content);
        
        this.loadingRequired = true;
        this.getRoles().subscribe(x => {
            //console.log(x.roles);
            if (x.roles != false) {
                if (Array.isArray(x.roles)) {
                    x.roles.forEach(i => {
                        this.c_obj.permList.push(i);
                    });
                }
            }

            //counter extra data
            var batch = [];
            batch.push(this.getDivisions());

            this.loadingRequired = true;

            const source = concat(...batch).pipe(
                last(),
                concatMap(y => {
                    return of(true);
                }),
                catchError(data => {return of(false)})
            );

            source.subscribe(x => {
                //console.log('terminado filters load');
                this.loadingRequired = false;
            });

        });
    }

    openUpdateModal(content: any, obj: any) {
        obj.permList = [];
        this.listUsers = [];

        this.rows.forEach(r => {
            this.listUsers.push({ext_id: r.ext_id, name: r.name});
        });

        //console.log(this.listUsers);
        if( (obj['SupervisorID'] != undefined) && (obj['SupervisorID'] != null) ){
            let tmp = this.listUsers.filter(r => r.ext_id == obj['SupervisorID']);
            //console.log(tmp);
            if( tmp.length > 0 ){
                obj['supervisor'] = {ext_id: tmp[0].ext_id, name: tmp[0].name};
            }
        }

        super.openUpdateModal(content, obj);

        this.loadingRequired = true;
        this.getRoles().subscribe(x => {
            if (x.roles != false) {
                if (Array.isArray(x.roles)) {
                    x.roles.forEach(i => {
                        //this.u_obj.permList.push(i);
                        this.u_obj.permList.push({id: i.id, name: i.name});
                    });
    
                    this.u_obj.permList.forEach(p => {
                        let tmp = this.u_obj.roles.filter(i => { return i.id == p.id });
                        if( tmp.length > 0 ){
                            //console.log(tmp[0]);
                            this.u_obj['role'] = {id: tmp[0].id, name: tmp[0].name};
                            //console.log(this.u_obj);
                        }
                    });
                }
            }

            //counter extra data
            var batch = [];
            batch.push(this.getDivisions());

            this.loadingRequired = true;

            const source = concat(...batch).pipe(
                last(),
                concatMap(y => {
                    return of(true);
                }),
                catchError(data => {return of(false)})
            );

            source.subscribe(x => {
                //console.log('terminado filters load');
                this.loadingRequired = false;
            });
        });
    }

    validateCreateInfo(fields: any) {
        let mygroup: any = {};
        mygroup = new FormGroup({
            'name': new FormControl(fields.name, [Validators.required]),
            'email': new FormControl(fields.email, [Validators.required, Validators.email]),
            'password': new FormControl(fields.password, [Validators.required]),
            'role': new FormControl(fields.role, [Validators.required])
        });

        return mygroup.valid;
    }

    validateUpdateInfo(fields: any) {
        let mygroup: any = {};
        mygroup = new FormGroup({
            'name': new FormControl(fields.name, [Validators.required]),
            'email': new FormControl(fields.email, [Validators.required, Validators.email]),
            'role': new FormControl(fields.role, [Validators.required])
        });

        return mygroup.valid;
    }

    public createItem(content: any, form: any) {
        var validated = true;
        //console.log(form);return;

        if (form == undefined) {
            form = {};
        }

        validated = this.validateCreateInfo(form);
        if (!validated) {
            Swal.fire(this.translations['msg_all_required'], '', 'error');
            return;
        }

        var to: any;
        to = {};
        to.name = form['name'];
        to.email = form['email'];
        to.password = form['password'];
        to.IdRol = form['role']['id'];
        
        if( form['ext_id'] ){
            to['ext_id'] = form['ext_id'];
        }

        if( form['ext_code'] ){
            to['ext_code'] = form['ext_code'];
        }

        if (form['supervisor']) {
            to.SupervisorID = form['supervisor']['ext_id'];
        }

        var qst = this.create_url;
        this.isCreating = true;

        this.srv.postCall(qst, to).subscribe(x => {
            this.isCreating = false;
            if (x.status) {
                this.c_obj = {};
                this.getList();
                this.closeModal(content);
                Swal.fire(this.translations.created, '', 'success');
            }//end success
            else {
                let err = x.message.Error.msg;
                Swal.fire(err, '', 'error');
            }
        });
    }

    public updateItem(content: any, form: any) {
        var validated = true;

        if (form == undefined) {
            form = {};
        }

        validated = this.validateUpdateInfo(form);
        if (!validated) {
            Swal.fire(this.translations['msg_all_required'], '', 'error');
            return;
        }

        var to: any;
        to = {};
        to.id = form['id'];
        to.name = form['name'];
        to.email = form['email'];
        to.password = form['password'];
        to.IdRol = form['role']['id'];
        
        if( form['ext_id'] ){
            to['ext_id'] = form['ext_id'];
        }

        if( form['ext_code'] ){
            to['ext_code'] = form['ext_code'];
        }

        if (form['supervisor']) {
            to.SupervisorID = form['supervisor']['ext_id'];
        }

        //var qst = this.update_url + '/' + form.id;
        var qst = this.update_url;
        this.isUpdating = true;

        this.srv.postCall(qst, to).subscribe(x => {
            this.isUpdating = false;
            if (x.status) {
                this.getList();
                this.closeModal(content);
                Swal.fire(this.translations['updated'], '', 'success');
            }//end success
            else {
                let err = x.message.Error.msg;
                Swal.fire(err, '', 'error');
                //this.closeModal(content);
            }
        });
    }

    searchUsers = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(200),
            distinctUntilChanged(),
            map(term => term.length < 2 ? []
                : this.listUsers.filter(v => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
        );

    formatterUsers = (x: any) => x.name;

    public getDivisions() {
        return of(true);
        var par_url = 'division/all';
        return this.srv.getCall(par_url).pipe(
            mergeMap(x => {
                let mydata: any = { status: false, message: '', data: [] };
                mydata = x;

                if ( (mydata.status == true) && (mydata.data) ) {
                    this.listSpecialAgents = mydata.data;
                    return of(true);
                    //return of(mydata.data);
                }
                else {
                    return of(false);
                }
            }),
            //timeout(MAX_TIME),
            catchError(data => of(false))
        );
    }

}
